import { AgCharts } from "ag-charts-react";
import { ChartBarIcon } from "@heroicons/react/outline";
import { AgChartOptions } from "ag-charts-community";

import LoadingSpinner from "@/components/LoadingSpinner";

const DeploymentUsageChartContent = ({
  chartOptions,
  isChartLoading,
  isEmpty,
  isError,
}: {
  chartOptions: AgChartOptions;
  isChartLoading: boolean;
  isEmpty: boolean;
  isError: boolean;
}) => (
  <div className="relative h-[320px] w-full shrink-0 px-1.5">
    <div
      className={`h-full w-full overflow-hidden rounded-lg ${isChartLoading || isEmpty ? "blur-sm" : ""}`}
    >
      <AgCharts options={chartOptions} className="h-full w-full" />
    </div>

    {isChartLoading && (
      <div className="absolute inset-0 flex items-center justify-center bg-white/95">
        <div className="flex items-center gap-3">
          <LoadingSpinner size={5} />
          <span className="text-sm font-medium">Loading deployment usage…</span>
        </div>
      </div>
    )}

    {isEmpty && !isChartLoading && !isError && (
      <div className="absolute inset-0 flex items-center justify-center bg-white/95">
        <div className="text-center">
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
            <ChartBarIcon className="h-6 w-6 text-gray-400" />
          </div>
          <div className="mb-1 text-sm font-medium text-gray-700">No deployment usage found</div>
          <div className="text-xs text-gray-500">
            Deployment runs with token usage will appear here
          </div>
        </div>
      </div>
    )}

    {isError && !isChartLoading && (
      <div className="absolute inset-0 flex items-center justify-center bg-white/95">
        <div className="text-center">
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-red-50">
            <ChartBarIcon className="h-6 w-6 text-red-400" />
          </div>
          <div className="mb-1 text-sm font-medium text-gray-700">
            Could not load deployment usage
          </div>
          <div className="text-xs text-gray-500">
            Check the billing endpoint response and try refreshing the page
          </div>
        </div>
      </div>
    )}
  </div>
);

export default DeploymentUsageChartContent;
